// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as AgentsAPI from "./agents.mjs";
import { Agents } from "./agents.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Blocks extends APIResource {
    constructor() {
        super(...arguments);
        this.agents = new AgentsAPI.Agents(this._client);
    }
    /**
     * Create Block
     */
    create(body, options) {
        return this._client.post('/v1/blocks/', { body, ...options });
    }
    /**
     * Retrieve Block
     */
    retrieve(blockID, options) {
        return this._client.get(path `/v1/blocks/${blockID}`, options);
    }
    /**
     * Update Block
     */
    update(blockID, body, options) {
        return this._client.patch(path `/v1/blocks/${blockID}`, { body, ...options });
    }
    /**
     * List Blocks
     */
    list(query = {}, options) {
        return this._client.getAPIList('/v1/blocks/', (ArrayPage), { query, ...options });
    }
    /**
     * Delete Block
     */
    delete(blockID, options) {
        return this._client.delete(path `/v1/blocks/${blockID}`, options);
    }
}
Blocks.Agents = Agents;
//# sourceMappingURL=blocks.mjs.map